import { render, staticRenderFns } from "./pardakht-shakhsi-filter.vue?vue&type=template&id=39a42e02"
import script from "./pardakht-shakhsi-filter.vue?vue&type=script&lang=js"
export * from "./pardakht-shakhsi-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports